<ng-template vdrDialogTitle>
  压缩后仍超过大小的图片
</ng-template>

<div class="oversize-images-dialog">
  <div class="dialog-content">
    <p class="description">
      以下图片压缩后仍然超过 {{ formatFileSize(1024000) }}，无法上传。您可以下载这些图片进行手动处理。
    </p>

    <div class="file-list">
      <div class="file-item" *ngFor="let file of files; let i = index">
        <div class="file-info">
          <span class="file-index">{{ i + 1 }}.</span>
          <span class="file-name" [title]="file.name">{{ file.name }}</span>
          <span class="file-size">({{ formatFileSize(file.size) }})</span>
        </div>
        <button class="btn btn-sm btn-secondary" (click)="downloadFile(file)">
          下载
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template vdrDialogButtons>
  <button class="btn" (click)="close()">关闭</button>
  <button class="btn btn-primary" (click)="downloadAll()">
    一键下载全部
  </button>
</ng-template>

